export const getBarTitle = (dealType: string, objectTypeName: string, rentDuration: string) => {
  return (
    (dealType === 'rent' ? 'Аренда ' : 'Продажа ') +
    objectTypeName.toLowerCase() +
    (rentDuration === 'short' ? ' посуточно' : '')
  );
};
